<template>
  <section class="friend-links">
    <ArticleOtherLinks
      :links="friendLinks"
      :titleImage="{
        src: 'friend-link',
        alt: articleTitle,
        mode: 'medium',
        target: 'blank',
      }"
    />
  </section>
</template>

<script>
import { getArticleString } from '@/config/articleString';
import { friendLinks } from '@/config/friendLinks';
import { getAllArticles } from '@/utils/sitemap';
import ArticleOtherLinks from '@/components/article/ArticleOtherLinks';

export default {
  name: 'Friendlinks',
  metaInfo() {
    return {
      title: '友善連結列表',
      meta: [
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.productionWholeReference,
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: '臺南宗教藝術-友善連結列表',
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: '歡迎一起查看跟我們有關係的台南旅遊網站喔。',
        },
      ],
    };
  },
  data() {
    return {};
  },
  computed: {
    articleTitle() {
      return getArticleString('friend', 'headline');
    },
    friendLinks() {
      return friendLinks;
    },
    getAllArticles() {
      return getAllArticles;
    },
    productionWholeReference() {
      return `${this.$store.getters.productionHostname}${window.location.pathname}${window.location.search}`;
    },
  },
  created() {},
  mounted() {
    // 為了產出動態且完整的 sitemap
    // this.getAllArticles();
  },
  methods: {},
  components: {
    ArticleOtherLinks,
  },
};
</script>

<style lang="scss" scoped>
.friend-links {
  margin-top: 30px;

  @include for-tablet {
    margin-top: 90px;
  }

  @include for-desktop {
    margin-top: 100px;
  }

  /deep/ .flex-container {
    margin: auto;

    @include for-tablet {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      max-width: 650px;
    }

    @include for-desktop {
      max-width: 900px;
    }

    .other-link {
      @include for-tablet {
        flex-basis: 48%;
        margin-bottom: 10px;
      }

      @include for-desktop {
        flex-basis: 32%;
      }

      &__link {
        @include for-desktop {
          padding-left: 52px;
        }
      }
    }

    .other-link + .other-link {
      @include for-tablet {
        margin-top: 0;
      }
    }
  }
}
</style>
